import {Component, Input} from '@angular/core';
import {DropzoneConfigInterface, DropzoneModule} from "ngx-dropzone-wrapper";
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {GeneralService} from "../../../../core/services/general.service";
import {EventService} from "../../../../core/services/event.service";
import {CommonSvgIconsComponent} from "../../../../shared/components/common-svg-icons/common-svg-icons.component";
import {CurrencyPipe} from "@angular/common";
import {TableService} from "../../../../core/services/table.service";
import {environment} from "../../../../../environments/environment";
const END_POINT = `${environment.SERVICES_URL}`;
const API_KEY = `${environment.API_KEY}`;

@Component({
  selector: 'app-new-event',
  standalone: true,
  imports: [
    CommonSvgIconsComponent,
    CurrencyPipe,
    DropzoneModule,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './new-event.component.html',
  styleUrl: './new-event.component.scss'
})
export class NewEventComponent {
  @Input() confirmAction!: () => void;
  @Input() data: any;
  @Input() isRelated: boolean;
  @Input() typeAction: any;

  textDropzone = '<i class="icon-cloud-up"></i>';
  public config: DropzoneConfigInterface = {
    clickable: true,
    addRemoveLinks: true,
    dictRemoveFile: 'Eliminar archivo',
    url: `${END_POINT}/serviceevent/upimages`,
    method: 'post',
    maxFilesize: 5,
    acceptedFiles: 'image/*,application/pdf',
    paramName: 'file',
    headers: {
      'X-Api-Key': `${API_KEY}`,
    }
  };
  public serviceList: any = [];
  public typeEventlist: any = [];
  public reasonEventlist: any = [];
  evidencesUploaded: string[] = [];
  public evidenceFrom: FormGroup;
  constructor(public modal: NgbModal, private fb: FormBuilder, private generalService:GeneralService, private serviceEvent:EventService, private tableService: TableService){
    this.evidenceFrom= this.fb.group({
      id: [null],
      service_id:["", Validators.required],
      event_date:["", Validators.required],
      event_type_id:["", Validators.required],
      reason_id:["", Validators.required],
      assigned:["", Validators.required],
      deductible:["", Validators.required],
      event_description:[""],
      amount:["", Validators.required],
      relatedEventId:[""],
      evidence: [],
      evidenceDelete: [],
    });
  }

  ngOnInit(): void {
    this.evidenceFrom.reset();
    this.loadList({"conditionColumn":"configurableListsField",
      "conditionValue":"Motivo del evento",
      "idColumn":"idconfigurableLists",
      "table":"confList",
      "valueColumn":"configurableListsCode"}, (value) => {this.typeEventlist = value;});

    this.loadList({"conditionColumn":"configurableListsField",
      "conditionValue":"Tipo Evento",
      "idColumn":"idconfigurableLists",
      "table":"confList",
      "valueColumn":"configurableListsCode"}, (value) => {this.reasonEventlist = value;});
    if(this.typeAction == 'edit') {
      this.evidenceFrom.patchValue({
        id: this.data["idEvent"],
        service_id:this.data["service_events.service_id"],
        event_date:this.data["service_events.event_date"],
        event_type_id:this.data["typeService.idconfigurableLists"],
        reason_id:this.data["reason.idconfigurableLists"],
        assigned:this.data["service_events.assignedId"],
        deductible:this.data["service_events.deductibleId"],
        event_description:this.data["service_events.event_description"],
        amount:this.data["service_events.amount"],
      });
      // Añadirlo al Dropzone manualmente
      let evidenceList = this.data["evidence_urls"]
          ? this.data["evidence_urls"].split(',').map((e: string) => e.trim()).filter((e: any) => !!e)
          : [];

      this.evidencesUploaded = evidenceList;
      this.evidenceFrom.patchValue({
        evidence: evidenceList
      });
      this.evidencesDelete = [];
      this.evidenceFrom.patchValue({
        evidenceDelete: this.evidencesDelete
      });

      // Esperar a que Dropzone esté montado (en caso de estar oculto antes)
      setTimeout(() => {
        const dropzoneEvidenceList = this.evidenceFrom.value.evidence;

        if (this.dropzoneInstance && dropzoneEvidenceList.length) {
          this.dropzoneInstance.removeAllFiles(true);

          dropzoneEvidenceList.forEach((url: string) => {
            const filename = this.getFileNameFromUrl(url);
            const mockFile = {
              name: filename,
              size: 123456,
              accepted: true,
              serverFileName: filename
            };

            this.dropzoneInstance.emit("addedfile", mockFile);

            const isImage = url.match(/\.(jpeg|jpg|png|gif)$/i);
            if (isImage) {
              this.dropzoneInstance.emit("thumbnail", mockFile, url);
            } else {
              this.dropzoneInstance.emit("thumbnail", mockFile, "assets/pdf-icon.png");
            }

            this.dropzoneInstance.emit("complete", mockFile);
          });
        }
      }, 300);
    }
    if(this.typeAction == 'related') {
      this.evidenceFrom.patchValue({
        relatedEventId: this.data["idEvent"],
        service_id:this.data["service_events.service_id"],
        event_date:this.data["service_events.event_date"]
      });
      //this.evidenceFrom.get('service_id')?.disable();
    }

    this.getService();
  }

  getFileNameFromUrl(url: string): string {
    return url.substring(url.lastIndexOf('/') + 1);
  }

  /**
   * Funciones para crear, editar y eliminar registros
   */
  getService(){
    this.serviceEvent.getAssignedServices().subscribe(
        (res: any) => {
          if (res.error) {
            this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
          } else {
            if(res.data != 0) {
              this.serviceList = res.data;
            } else {
              this.generalService.showMessage('success', res.message);
            }
          }
        },
        (err) => {
          this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
        }
    )
  }

  addNewEvent(): void {
    //this.evidenceFrom.get('eventId')?.setValue(this.data.idEvent);
    if (this.evidenceFrom.valid) {
      // Actualiza el form con el nuevo array
      this.evidenceFrom.patchValue({
        evidence: this.evidencesUploaded
      });
      // Delete
      this.evidenceFrom.patchValue({
        evidenceDelete: this.evidencesDelete
      })

      this.serviceEvent.add(this.evidenceFrom.value).subscribe(
          (res: any) => {
            if (res.error) {
              this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
            } else {
              this.generalService.showMessage('success', res.message);
              this.cancelForm();
              this.confirmAction();
            }
          },
          (err: any) => {
            this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
          }
      )
    } else {
      this.generalService.showMessage('warn', 'LLene toda la información solicitada');
    }

  }

  //Función para cancelar nuevo registro
  cancelForm(): void {
    this.evidenceFrom.reset();
    this.modal.dismissAll();
  }

  /**
   * Funciones para la carga de archivos
   */
  dropzoneInstance: any; // Esto será la instancia real de Dropzone
  onDropzoneInit(dropzone: any): void {
    this.dropzoneInstance = dropzone;
  }

  onUploadError(args: any): void {
    console.log('warn', args);
  }

  onUploadSuccess(event: any): void {
    let file = event[0];
    let response = event[1]; // Aquí viene el `response`

    if (response.success) {
      event.serverFileName = response.name;
      this.evidencesUploaded.push(response.url);
    }
  }
  evidencesDelete: string[] = [];
  onRemoveSuccess(file: any): void {
    const nombreArchivo = file.serverFileName; // Un campo extra que vamos a poner al subir
    this.evidencesDelete.push(nombreArchivo);
    const index = this.evidencesUploaded.findIndex(url => url.includes(nombreArchivo));
    // Si lo encuentra, lo remueve
    if (index > -1) {
      this.evidencesUploaded.splice(index, 1);
    }
  }



  /**
   * Funcion paa cargar listas configurables
   * @param config
   * @param setVariable
   */
  loadList(config: any, setVariable: (value: any) => void):void {
    this.tableService.loadSelectOptions(config).subscribe(
        (res: any) => {
          if (res.error) {
            this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
            setVariable([]);
          } else {
            setVariable(res['message']);
          }
        },
        (err) => {
          this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
          setVariable([]);
        }
    );
  }
}
